export const workspaceQueryKeys = {
  root: (orgId: string) => ['workspaces', orgId] as const,
  list: (orgId: string) => [...workspaceQueryKeys.root(orgId), 'list'] as const,
  profileGroups: (orgId: string, workspaceId: string) =>
    [...workspaceQueryKeys.root(orgId), 'profile-groups', workspaceId] as const,
};
